// Build-time site key. When unset (local dev without a Cloudflare account)
// the widget is skipped and bootstrap fires immediately. The backend mirrors
// this — it only enforces Turnstile when TURNSTILE_SECRET_KEY is set, so the
// two need to be set together.
export const TURNSTILE_SITE_KEY = import.meta.env
  .VITE_PUBLIC_TURNSTILE_SITE_KEY as string | undefined;

// Cross-tier contract: must match PUBLIC_JAN_TURNSTILE_ACTION in
// backend/middleware/publicJan/turnstile.ts. Cloudflare rejects the token
// with `action_mismatch` if these drift.
export const TURNSTILE_ACTION = "public_jan_session_start";
